import React from 'react';

interface HouseProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const House = ({ fill = 'black', width = 16, height = 16 }: HouseProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.7328 2.20709L8.02982 1.5L1 8.5709L1.70298 9.27799L1.99416 8.9851L1.99416 13.5L1.99416 14.5H6.965V13.5H6.96497V9.49997L8.95326 9.49997V14.4999H8.95338V14.5H13.9242V13.5H13.9242V8.84336L14.3567 9.27841L15.0597 8.57132L8.73262 2.20728L8.7328 2.20709ZM8.02963 2.91437L2.98833 7.98513V13.5H5.97081V8.5H5.9709H6.96497H8.95326H9.94742H9.94757V9.49997H9.94742V13.5H12.93V7.84338L8.02963 2.91437Z"
            fill={fill}
        />
    </svg>
);
